import React from "react";
import "./keyfeatures.css";
import Reveal from "../../utils/Reveal";

const features = [
  {
    title: "Real-Time Tracking",
    icon: "📡",
    description:
      "Utilizing advanced tracking systems, we offer real-time visibility into your shipment's status, enhancing transparency and enabling proactive management.",
  },
  {
    title: "Compliance and Certification",
    icon: "🛡️",
    description:
      "Our adherence to TAPA standards and other industry certifications underscores our commitment to maintaining the highest security and quality protocols.",
  },
  {
    title: "Expertise in High-Tech Logistics",
    icon: "💼",
    description:
      "Our team's specialized knowledge in handling sensitive and valuable technological equipment ensures that your products are managed with the utmost care and professionalism.",
  },
];

const KeyFeatures = () => {
  return (
    <section className="container py-5" id="key-features">
      <div className="text-center mb-4"></div>
      <div className="row">
        {features.map((feature, index) => (
          <div className="col-md-4 mb-4 " key={index} shadow-lg>
            <Reveal animationType={index % 2 === 0 ? "fadeInUp" : "fadeInDown"}>
              <div className="feature-box p-4 h-100 rounded">
                <div className="feature-icon display-5 mb-3">
                  {feature.icon}
                </div>
                <h5 className="fw-bold">{feature.title}:</h5>
                <p>{feature.description}</p>
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </section>
  );
};

export default KeyFeatures;
